"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("./utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppController = function () {
  function AppController(NavigationService, FilterService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AppController);
    this.navigationService = NavigationService;
    this.filterService = FilterService;
    // this.getGlobaFilterOptions();
  }

  (0, _createClass3.default)(AppController, [{
    key: "$onInit",
    value: function $onInit() {}
  }, {
    key: "hideNav",
    value: function hideNav() {
      return this.navigationService.isCurrent("login");
    }
  }, {
    key: "hideGlobalFilters",
    value: function hideGlobalFilters() {
      // return !this.navigationService.isCurrent("users");
      return false;
    }
  }, {
    key: "getGlobalFilterOptions",
    value: function getGlobalFilterOptions() {
      var filterOptions = void 0;

      if (this.navigationService.isCurrent(_constants2.default.screens.USERS)) {
        filterOptions = this.filterService.getGlobalUsersFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.JOBS)) {
        filterOptions = this.filterService.getGlobalJobsFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.JOB_REQUESTS)) {
        filterOptions = this.filterService.getGlobalJobRequestsFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.AFFILIATES)) {
        filterOptions = this.filterService.getGlobalAffiliatesFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.CERTIFICATES)) {
        filterOptions = this.filterService.getGlobalCertificatesFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.CHECKS)) {
        filterOptions = this.filterService.getGlobalCheckssFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.BOT_MANAGER)) {
        filterOptions = this.filterService.getGlobalBotManagerFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.BOT_SESSIONS)) {
        filterOptions = this.filterService.getGlobalBotSessionsFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.VOUCHES)) {
        filterOptions = this.filterService.getGlobalVocuhesFilterOptions();
      } else if (this.navigationService.isCurrent(_constants2.default.screens.BUSINESSES)) {
        filterOptions = this.filterService.getGlobalBusinessesFilterOptions();
      }

      return filterOptions;
    }
  }]);
  return AppController;
}();

exports.default = AppController;


/** WEBPACK FOOTER **
 ** ./client/app/app.controller.js
 **/